<template>
	<div>
		<!-- 第一列 -->
		<el-form class="left" ref="defForm" :rules="rules" :model="defForm" label-width="120px">
			<el-form-item label="业务名称" prop="title">
				<el-input v-model="defForm.title" placeholder="请输入业务名称"></el-input>
			</el-form-item>
			<el-form-item label="业务编码" prop="code">
				<el-input v-model="defForm.code" placeholder="请输入业务编码"></el-input>
			</el-form-item>
			<el-form-item label="专业律师" prop="lawyers">
				<el-select v-model="defForm.lawyers" placeholder="请选择专业律师" filterable  multiple  >
					<el-option
						v-for="item in treeData"
						:key="item.id"
						:label="item.name"
						:value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			
			<el-form-item label="业务范围" prop="services">
				<el-input v-model="defForm.services" placeholder="请输入业务范围(多个以、隔开)"></el-input>
			</el-form-item>

			<el-form-item label="图标1" prop="icon1">
				<el-upload class="avatar-uploader" 
					action="string" 
					:show-file-list="false" 
					:http-request="uploadIcon1"
					:before-upload="beforeAvatarUpload">
					<img v-if="defForm.icon1" :src="defForm.icon1" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</el-form-item>	
		</el-form>
		<!-- 第二列 -->
		<el-form class="right" ref="defForm1" :rules="rules" :model="defForm" label-width="120px">
			<el-form-item label="图片" prop="image">
				<el-upload class="avatar-uploader" 
					action="string" 
					:show-file-list="false" 
					:http-request="uploadImg"
					:before-upload="beforeAvatarUpload">
					<img v-if="defForm.image" :src="defForm.image" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</el-form-item>	
			<el-form-item label="业务英文" prop="e_title">
				<el-input v-model="defForm.e_title" placeholder="请输入业务英文"></el-input>
			</el-form-item>
			<el-form-item label="发布时间" prop="publish">
				<el-date-picker
					v-model="defForm.publish" 
					type="date" 
					value-format="yyyy-MM-dd HH:MM:SS"
					placeholder="请输入发布日期" >
				</el-date-picker>
			</el-form-item>

			<el-form-item label="图标2" prop="icon2">
				<el-upload class="avatar-uploader" 
					action="string" 
					:show-file-list="false" 
					:http-request="uploadIcon2"
					:before-upload="beforeAvatarUpload">
					<img v-if="defForm.icon2" :src="defForm.icon2" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
			</el-form-item>	
		</el-form>
		<!-- 编辑器 -->
		<el-form ref="defForm2" :rules="rules" :model="defForm" label-width="120px">
			<el-form-item label="业务介绍" prop="content">
				<v-md-editor v-model="defForm.content" height="300px" :disabled-menus="[]" @upload-image="handleUploadImage" ></v-md-editor>
			</el-form-item>
		</el-form>
		<!-- 按钮部分 -->
		<div class="button" style="margin-left: 100px;">
			<el-button type="primary" @click="$router.back()">返回</el-button>
			<el-button type="primary" :loading="loading" @click="submitForm(defForm)">保存</el-button>
		</div>
	</div>
</template>
<script>
	import '@riophae/vue-treeselect/dist/vue-treeselect.css'
	import {create,upload} from '@/api/service'
	import {queryLawyer} from "@/api/lawyer";
	import token from "@/token.js";
	export default {
		name: "Add",
		data() {
			return {
				defForm: {
					title: '',
					e_title:'',
					code:'',
					lawyers:[],
					lawyer_ids: null,
					services: '',
					image: '',
					icon1:'',
					icon2:'',
					publish: '',
					content: '',
					createUserID: token.getUser().id,
					createUserName: token.getUser().manager_username
				},
				treeData: [],
				loading: false,
				rules: {
					title: [{
						required: true,
						message: '必填项不能为空'
					}]
				}
			}
		},

		created() {
			let param = {
					page: 1,
					pageSize: 99999,
				}
			queryLawyer(param).then(data => {
				this.treeData = data.data.list
				console.log(this.treeData)
			}).catch(error => {
				this.$message.error(error)
			})
		},
		methods: {
			submitForm(form) {
				this.$refs['defForm'].validate(valid => {
					if (valid) {
						if(this.defForm.lawyers && this.defForm.lawyers.length > 0){
							this.defForm.lawyer_ids = this.defForm.lawyers.toString()
						}else{
							this.defForm.lawyer_ids = ''
						}
						console.log("新增",this.defForm)
						this.loading = true
						create(this.defForm).then(data => {
							this.loading = false
							this.$refs['defForm'].resetFields()
							this.$message.success("新增成功!")
							this.$router.push('/admin/service/serviceindex')
						}).catch(error => {
							this.loading = false
							this.$message.error(error)
						})
					}
				})
			},
			close() {
				this.$emit("hideDialog")
			},
			uploadImg(param) {
				let formData = new FormData();
				formData.append("file", param.file)
				upload(formData).then(data => {
					this.defForm.image = data.data
				}).catch(error => {
					this.$message.error(error)
				})
			},
			uploadIcon1(param) {
				let formData = new FormData();
				formData.append("file", param.file)
				upload(formData).then(data => {
					this.defForm.icon1 = data.data
				}).catch(error => {
					this.$message.error(error)
				})
			},
			uploadIcon2(param) {
				let formData = new FormData();
				formData.append("file", param.file)
				upload(formData).then(data => {
					this.defForm.icon2 = data.data
				}).catch(error => {
					this.$message.error(error)
				})
			},
			//上传之前的验证
			beforeAvatarUpload(file) {
				const isIMAGE = (file.type === 'image/jpeg') || (file.type === 'image/jpg') || (file.type === 'image/png')
				if (!isIMAGE) {
					this.$message.error('上传文件只能是图片格式!')
				}
				return isIMAGE 
			},
			handleUploadImage(event, insertImage, files){
				console.log(files)
				for (let i = 0; i < files.length; i++) {
					let formData = new FormData();
					formData.append("file", files[i])
					upload(formData).then(data => {
						insertImage({
              url: data.data,
              desc: files[i].name
            });
					}).catch(error => {
						this.$message.error(error)
					})
        }
			},
		}
	}
</script>

<style scoped>
	div ::v-deep .el-date-editor{
		width: 100%;
	}
	div ::v-deep .el-select{
		width: 100%;
	}
	.left{
		width: 50%;
		display: inline-block;
	}
	.right{
		width: 50%;
		display: inline-block;
	}
	.avatar-uploader {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		width: 80px;
		height: 80px;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 80px;
		height: 80px;
		line-height: 80px;
		text-align: center;
	}

	.avatar {
		width: 80px;
		height: 80px;
		display: block;
	}
</style>
